import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import useStyles from "./styles";
import { Add, DeleteOutline, StorageOutlined } from "@mui/icons-material";

const ERP = `${
  window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP || ""
}`;

const LABELERP =
  ERP === "HUBSOFT"
    ? "Serviço"
    : ERP === "VOALLE"
      ? "Contrato"
      : ERP === "IXC"
        ? "Contrato"
        : "Serviço";

function HostsSelector({
  loading = {},
  editMode = false,
  blockedHostIds = [],
  manipulateCpes = [],
  availableHosts = [],
  availableDevices = [],
  setManipulateCpes = () => {},
}) {
  const theme = useTheme();
  const styles = useStyles(theme);

  /** ADICIONAR / REMOVER CPE */
  const handleAddCpe = () => {
    const newCpe = {
      groupId: "",
      selectedHosts: [],
    };

    setManipulateCpes?.([...(manipulateCpes ?? []), newCpe]);
  };

  const handleRemoveCpe = (index) => {
    const newCpes = [...(manipulateCpes ?? [])];
    newCpes.splice(index, 1);
    setManipulateCpes?.(newCpes);
  };

  /** OBTER OPÇÕES */
  const getAvailableModels = (currentIndex) => {
    const selectedGroupIds = manipulateCpes
      ?.filter((_, idx) => idx !== currentIndex)
      ?.map((onu) => onu?.groupId)
      ?.filter(Boolean);

    return availableDevices?.filter(
      (device) => !selectedGroupIds?.includes(device?.groupid),
    );
  };

  const getAvailableHosts = (currentIndex, selectedGroupId) => {
    if (!selectedGroupId) return [];

    const hasSameGroup = availableHosts?.filter((host) =>
      host?.groups?.some(
        (group) =>
          group?.groupid === selectedGroupId &&
          !blockedHostIds.includes(host?.hostid),
      ),
    );
    return hasSameGroup;
  };

  /** SELECIONAR OPÇÕES */
  const handleModelSelect = (index, value) => {
    const newCpes = [...(manipulateCpes ?? [])];

    newCpes[index] = {
      ...(newCpes[index] ?? {}),
      groupId: value?.groupid || "",
      selectedHosts: [],
    };

    setManipulateCpes?.(newCpes);
  };

  const handleHostSelect = (index, newValues) => {
    const newCpes = [...(manipulateCpes ?? [])];

    newCpes[index] = {
      ...(newCpes[index] ?? {}),
      selectedHosts: newValues ?? [],
    };

    setManipulateCpes?.(newCpes);
  };

  return (
    <Box sx={styles?.container}>
      <Box sx={styles?.boxTitle}>
        <StorageOutlined color="primary" sx={styles.addDeviceIcon} />
        <Typography variant="mySubtitle2">Hosts:</Typography>
        {/* <Button
          variant="outlined"
          size="small"
          startIcon={<Add color="primary" />}
          onClick={handleAddCpe}
          disabled={!editMode || !!Object.values(loading)?.some(Boolean)}
        >
          Adicionar
        </Button> */}
      </Box>

      <Box sx={styles.boxMapOnus}>
        {manipulateCpes?.map?.((cpe, index) => {
          const availableModels = getAvailableModels(index);
          const currentModel = availableDevices?.find(
            (d) => d?.groupid === cpe?.groupId,
          );
          const availableHostsForModel =
            getAvailableHosts?.(index, cpe?.groupId) ?? [];

          const nonBlockedHosts = availableHostsForModel.filter(
            (h) => !blockedHostIds.some((b) => b.hostid === h.hostid),
          );

          const allSelected =
            cpe?.selectedHosts?.length > 0 &&
            cpe?.selectedHosts?.length === nonBlockedHosts.length;
          const hostOptions = [
            {
              isSelectAll: true,
              hostid: "select-all",
              host: allSelected ? "Limpar Seleção" : "Selecionar Todos",
            },
            ...(availableHostsForModel ?? []),
          ];

          return (
            <Box>
              <Grid container spacing={1} key={cpe?.groupId || index}>
                <Grid item xs={11.6}>
                  <Paper
                    variant="outlined"
                    elevation={0}
                    sx={styles.paperOnuItem}
                  >
                    <Grid container spacing={1}>
                      {/* Modelo */}
                      <Grid item xs={12} sm={6}>
                        <Autocomplete
                          size="small"
                          options={availableModels ?? []}
                          value={currentModel ?? null}
                          getOptionLabel={(option) => option?.name ?? ""}
                          isOptionEqualToValue={(option, value) =>
                            option?.groupid === value?.groupid
                          }
                          onChange={(event, newValue) =>
                            handleModelSelect?.(index, newValue)
                          }
                          renderInput={(params) => (
                            <TextField
                              variant="filled"
                              {...params}
                              label="Modelo"
                              placeholder="Selecione o modelo"
                            />
                          )}
                          disabled={
                            (availableModels?.length ?? 0) === 0 || !editMode
                          }
                        />
                      </Grid>
                      {/* Host */}
                      <Grid item xs={12} sm={6}>
                        <Autocomplete
                          multiple
                          size="small"
                          disableCloseOnSelect
                          options={
                            availableHostsForModel?.length > 1
                              ? hostOptions
                              : []
                          }
                          value={cpe?.selectedHosts ?? []}
                          onChange={(event, newValue, reason, details) => {
                            const clicked = details?.option;
                            if (clicked?.isSelectAll) {
                              if (allSelected) {
                                // limpar seleção
                                handleHostSelect(index, []);
                              } else {
                                // selecionar apenas os NÃO bloqueados
                                handleHostSelect(index, nonBlockedHosts);
                              }
                              return;
                            }
                            if (clicked?.divider) return;
                            handleHostSelect(index, newValue);
                          }}
                          getOptionLabel={(option) => option?.host ?? ""}
                          isOptionEqualToValue={(option, value) => {
                            const optionId = option.hostid || option.hostId;
                            const valueId = value.hostid || value.hostId;
                            return optionId === valueId;
                          }}
                          renderTags={(selected) => (
                            <Tooltip
                              placement="top"
                              title={
                                selected?.length ? (
                                  <Box sx={styles.hostFieldTooltip}>
                                    {selected?.map((item) => {
                                      const full = availableHostsForModel.find(
                                        (h) =>
                                          h.hostid ===
                                          (item.hostid || item.hostId),
                                      );
                                      return (
                                        <Typography
                                          key={item.hostid || item.hostId}
                                          sx={styles.hostFieldText}
                                        >
                                          {full?.host ??
                                            item.hostid ??
                                            item.hostId}
                                        </Typography>
                                      );
                                    })}
                                  </Box>
                                ) : (
                                  "Nenhum host selecionado"
                                )
                              }
                            >
                              <Box sx={styles.boxSelectedHost}>
                                {allSelected ? (
                                  <Typography
                                    variant="body2"
                                    noWrap
                                    sx={styles.hostFieldTextSelected}
                                  >
                                    Todos os Hosts selecionados
                                  </Typography>
                                ) : (
                                  <Typography
                                    variant="body2"
                                    noWrap
                                    sx={styles.hostFieldTextCounter}
                                  >
                                    {selected.length} Host
                                    {selected.length !== 1 ? "s" : ""}{" "}
                                    selecionado
                                    {selected.length !== 1 ? "s" : ""}
                                  </Typography>
                                )}
                              </Box>
                            </Tooltip>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="filled"
                              label="Hosts"
                              placeholder={
                                cpe?.selectedHosts?.length > 0
                                  ? ""
                                  : "Selecione um ou mais hosts"
                              }
                            />
                          )}
                          renderOption={(props, option, { selected }) => {
                            // Selecionar Todos
                            const someSelected =
                              cpe?.selectedHosts?.length > 0 &&
                              cpe?.selectedHosts?.length <
                                availableHostsForModel?.length;
                            const selectAllChecked = allSelected;
                            const selectAllIndeterminate = someSelected;
                            // Bloqueado
                            const blockedInfo = blockedHostIds.find(
                              (b) => b.hostid === option.hostid,
                            );
                            const isBlocked = Boolean(blockedInfo);

                            if (option.isSelectAll) {
                              return (
                                <li {...props}>
                                  <Checkbox
                                    indeterminate={selectAllIndeterminate}
                                    checked={selectAllChecked}
                                    tabIndex={-1}
                                    disableRipple
                                    style={{ marginRight: 8 }}
                                  />
                                  <span
                                    style={{
                                      fontStyle: "italic",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {option.host}
                                  </span>
                                </li>
                              );
                            }

                            const optionLi = (
                              <li
                                {...props}
                                style={{
                                  opacity: isBlocked ? 0.5 : 1,
                                  pointerEvents: isBlocked ? "none" : "auto",
                                }}
                              >
                                <Checkbox
                                  checked={selected}
                                  tabIndex={-1}
                                  disableRipple
                                  style={{ marginRight: 8 }}
                                />
                                {option.host}
                              </li>
                            );
                            // Tooltip se estiver bloqueado
                            return isBlocked ? (
                              <Tooltip
                                title={`Já selecionado no ${LABELERP}: ${blockedInfo?.servico}`}
                                placement="top"
                              >
                                <div style={{ pointerEvents: "auto" }}>
                                  {optionLi}
                                </div>
                              </Tooltip>
                            ) : (
                              optionLi
                            );
                          }}
                          disabled={
                            !cpe?.groupId ||
                            (availableHostsForModel?.length ?? 0) === 0 ||
                            !editMode
                          }
                        />
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
                <Grid item xs={0.4} sx={styles?.deleteIcon}>
                  <IconButton
                    size="small"
                    onClick={() => handleRemoveCpe?.(index)}
                    disabled={!editMode}
                  >
                    <DeleteOutline color={editMode ? "error" : "disabled"} />
                  </IconButton>
                </Grid>
              </Grid>
            </Box>
          );
        })}
        <Button
          variant="outlined"
          size="small"
          startIcon={<Add color={theme.palette.text.main} />}
          onClick={handleAddCpe}
          sx={styles.button}
        >
          Novo host
        </Button>
      </Box>
    </Box>
  );
}

export default HostsSelector;
